import React from 'react';
import { Alert, Platform, Text, View } from 'react-native';
import config from '../config';
import init from 'react_native_mqtt';
import AsyncStorage from '@react-native-async-storage/async-storage';
import i18n from './../util/i18n';
import { Button, FormControl, Grid2, InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material';
import { getCategories } from '../services/category.service';
import { getSongs } from '../services/song.service';
import { pauseMusicSpotify, playMusicSpotify, spotifyConnectionStatus } from '../services/spotify.service';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

i18n.locale = navigator.language;

init({
    size: 10000,
    storageBackend: AsyncStorage,
    defaultExpires: 1000 * 3600 * 24,
    enableCache: true,
    reconnect: true,
    sync: {
    }
});

class Home extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            devices: [],
            categories: [],
            songs: [],
            device: '',
            category: '',
            song: '',

            selected_category: null,
            selected_song: null,
            local_audio_url: null,
            playing_local_audio_url: null,
            video_ref: React.createRef(),
            playing_video_ref: React.createRef(),

            buttonText: i18n.t('start'),
            loading: false,
            playing: false,
            mqttStatus: i18n.t('connecting_to_mqtt_broker'),
            countdown: '',
            timeoutTime: '',
            songsList: []
        };

        // Connect to MQTT broker here
        // generate random string for client id
        let clientId = Math.random().toString(36).substring(7);
        // this.client = new Paho.MQTT.Client(config.mqtt.host, clientId);
        let url = `${config.mqtt.host}`;
        this.client = new Paho.MQTT.Client(url, clientId);
        this.client.onConnectionLost = this.onConnectionLost;
        this.client.onMessageArrived = this.onMessageArrived;
        this.client.connect({
            useSSL: false,
            // userName:config.mqtt.user,
            // password:config.mqtt.pass,
            onSuccess: this.onConnect,
            onFailure: this.onFailure
        });
    }

    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve)
        });
    }

    switchToNextSong = async () => {
        let current_song_index = this.state.songs.findIndex(song => song._id == this.state.song);
        if (current_song_index < this.state.songs.length - 1) {
            let next_song = this.state.songs[current_song_index + 1];
            await this.setStateAsync({
                song: next_song._id,
                selected_song: next_song
            });
            await AsyncStorage.setItem('song', next_song._id);
            await AsyncStorage.setItem('selected_song', JSON.stringify(next_song));
            this.setLocalAudio();
        } else {
            let next_category_index = this.state.categories.findIndex(category => category._id == this.state.category);
            if (next_category_index < this.state.categories.length - 1) {
                let next_category = this.state.categories[next_category_index + 1];
                await this.setStateAsync({
                    category: next_category._id,
                    selected_category: next_category,
                    song: '',
                    selected_song: null
                });
                await AsyncStorage.setItem('category', next_category._id);
                await AsyncStorage.setItem('selected_category', JSON.stringify(next_category));
                this.populateSongs();
            }
        }
    }

    showCountdown = async (timeoutTime) => {
        let remainingTime = timeoutTime - new Date().getTime();
        this.setState({ countdown: parseInt(remainingTime / 1000) });
        if (remainingTime >= 0) {
            setTimeout(() => {
                if (this.state.countdown === '') {
                    return;
                }
                this.showCountdown(timeoutTime);
            }, 100);
        } else {
            this.setState({ loading: false, playing: false, buttonText: i18n.t('start'), countdown: '' });
            // // If the song is playing in spotify, then we can switch to the next song after the timeout, otherwise we will switch the song when the song ends, so we need to check the audio source of the song before switching to the next song
            // let audio_source = this.state.selected_song?.audio_source;
            // if (audio_source === 'spotify_url') {
                this.switchToNextSong();
            // }
        }
    }

    sendMqttMessage = (topic, message) => {
        this.setState({ buttonText: i18n.t('sending') });
        var message = new Paho.MQTT.Message(message);
        message.destinationName = topic;
        message.retained = true;
        this.client.send(message);
        this.setState({ buttonText: i18n.t('sent') });
    }


    async startLocalAudio() {
        try {

            await this.setStateAsync({
                playing_local_audio_url: this.state.local_audio_url
            });

            // if (this.state.video_ref.current) { // Check if the ref is set
            //     await this.state.video_ref.current.play(); // Call play() on the video element
            // }

            // TODO : Always switch to correct song first and then start playing the song

            if (this.state.playing_video_ref.current) { // Check if the ref is set
                await this.state.playing_video_ref.current.play(); // Call play() on the video element
            }
            return true;
        } catch (error) {
            console.log("Error playing local audio ", error);
            alert(i18n.t('error_playing_local_audio') + ": " + error);
            return false;
        }
    }

    async startSpotifyAudio() {
        try {

            await this.setStateAsync({
                playing_local_audio_url: null
            });

            if (!this.state.device) {
                if (Platform.OS === 'web') {
                    alert(i18n.t('please_enter_a_device_id'));
                } else {
                    Alert.alert(i18n.t('please_enter_a_device_id'));
                }
                return false;
            }

            let playRes = await playMusicSpotify({
                device_id: this.state.device,
                song_id: this.state.selected_song._id
            })

            if (playRes?.error) {
                alert("Error playing music " + playRes.error);
                return false;
            }

            return true;

        } catch (error) {
            console.log("Error playing spotify audio ", error);
            alert(i18n.t('error_playing_spotify_audio') + ": " + error);
            return false;
        }
    }


    async start() {

        if (!this.state.selected_song) {
            if (Platform.OS === 'web') {
                alert(i18n.t('please_enter_a_song_id'));
            } else {
                Alert.alert(i18n.t('please_enter_a_song_id'));
            }
            return;
        }

        if (this.state?.selected_song?.time == '') {
            if (Platform.OS === 'web') {
                alert(i18n.t('song_has_no_timeout'));
            } else {
                Alert.alert(i18n.t('song_has_no_timeout'));
            }
            return;
        }

        let played = false;
        if (this.state.selected_song.audio_source === 'audio_upload') {
            played = await this.startLocalAudio();
        } else {
            played = await this.startSpotifyAudio();
        }
        if (!played) {
            return;
        }

        this.setState({ loading: true, playing: true, buttonText: i18n.t('sending') });

        let timeout = this.state.selected_song.time;
        let solutionDisplay = this.state?.selected_song?.timeline?.solution_display_time || 0;
        let date = new Date();
        let timeoutTime = date.getTime() + (timeout * 1000)
        let solutionDisplayTime = date.getTime() + ((timeout + solutionDisplay) * 1000)
        
        this.setState({ timeoutTime: timeoutTime });

        this.sendMqttMessage(
            config.masterTopic + '/' + config.startKey,
            JSON.stringify({
                mode: 'start',
                timeoutTime: timeoutTime,
                solutionDisplayTime: solutionDisplayTime,
                timeoutTimeInSeconds: timeout,
                solutionDisplayTimeInSeconds: solutionDisplay,
                songId: this.state.song,
                categoryId: this.state.category,
                categoryName: this.state.selected_category?.name,
                songType: this.state.selected_song?.type,
                hasRelease: this.state.selected_song?.has_release || false,
                hasMovie: this.state.selected_song?.has_movie || false,
                hasArtist: this.state.selected_song?.has_artist || false,
                hasLanguage: this.state.selected_song?.has_language || false,
            }),
        );

        // this.showCountdown(solutionDisplayTime);
    }


    async stopLocalAudio() {
        try {
            // if (this.state.video_ref.current) { // Check if the ref is set
            //     await this.state.video_ref.current.pause(); // Call pause() on the video element
            //     // seek to start
            //     this.state.video_ref.current.currentTime = 0;
            // }
            if (this.state.playing_video_ref.current) { // Check if the ref is set
                await this.state.playing_video_ref.current.pause(); // Call pause() on the video element
                // seek to start
                this.state.playing_video_ref.current.currentTime = 0;
            }
            return true;
        } catch (error) {
            console.log("Error stopping local audio ", error);
            alert(i18n.t('error_stopping_local_audio') + ": " + error);
            return false;
        }
    }

    async stopSpotifyAudio() {
        try {

            

            if (!this.state.device) {
                if (Platform.OS === 'web') {
                    alert(i18n.t('please_enter_a_device_id'));
                } else {
                    Alert.alert(i18n.t('please_enter_a_device_id'));
                }
                return false;
            }

            let playRes = await pauseMusicSpotify({
                device_id: this.state.device
            })

            if (playRes?.error) {
                alert("Error pausing music " + playRes.error);
                return false;
            }

            return true;

        } catch (error) {
            console.log("Error stopping spotify audio ", error);
            alert(i18n.t('error_stopping_spotify_audio') + ": " + error);
            return false;
        }
    }


    async stop() {

        

        let paused = false;
        if (this.state.selected_song.audio_source === 'audio_upload') {
            paused = await this.stopLocalAudio();
        } else {
            paused = await this.stopSpotifyAudio();
        }
        if (!paused) {
            return;
        }

        

        this.sendMqttMessage(
            config.masterTopic + '/' + config.startKey,
            JSON.stringify({
                mode: 'stop'
            }),
        );

        this.setState({ loading: false, playing: false, buttonText: i18n.t('start'), countdown: '' });

    }

    onConnect = () => {
        console.log("Connected to MQTT Broker!");
        this.client.subscribe(config.mqtt.topic);
        this.setState({ mqttStatus: i18n.t('connected_to_mqtt_broker') });
    }

    onFailure = (responseObject) => {
        this.setState({ mqttStatus: i18n.t('connection_to_mqtt_broker_failed') });
        console.log("Connection to MQTT Broker Failed: ", responseObject.errorMessage);
    }

    onConnectionLost = (responseObject) => {
        if (responseObject.errorCode !== 0) {
            this.setState({ mqttStatus: i18n.t('connection_lost') });
            console.log("Connection Lost: ", responseObject.errorMessage);
        }
    }

    onMessageArrived = async (message) => {

        // let songId = message.topic.split('/')[2];
        let payload = JSON.parse(message.payloadString);
        let songId = payload.songId;
        let categoryId = payload.categoryId;
        let timeoutTime = payload.timeoutTime;

        const mode = payload.mode;
        if (mode === 'stop') {
            this.setState({ countdown: '' });
            return;
        }

        if (timeoutTime < new Date().getTime()) {
            console.log("Message timeout time is less than current time, ignoring the message");
            return;
        }

        await this.setStateAsync({
            songId: songId,
            categoryId: categoryId,
            hasArtist: payload.hasArtist,
            hasRelease: payload.hasRelease,
            hasMovie: payload.hasMovie,
            hasLanguage: payload.hasLanguage,
        });
        this.showCountdown(timeoutTime);
        this.setState({ timeoutTimeInSeconds: payload.timeoutTimeInSeconds });

    }

    async componentDidMount() {
        this.populateDevices();
        await this.populateCategories();
        this.setCategoryAndSongFromLocalStorage();
    }


    populateDevices = async () => {
        let spotifyConnectionStatusRes = await spotifyConnectionStatus();

        if (spotifyConnectionStatusRes?.error) {
            console.log("Error getting connection status " + spotifyConnectionStatusRes.error);
            return;
        }

        let devices = spotifyConnectionStatusRes?.devices || [];

        let asyncStorageDevice = await AsyncStorage.getItem('device');
        let deviceToSet = devices.find(device => device.id === asyncStorageDevice);
        if (!deviceToSet) {
            deviceToSet = devices?.[0]?.id;
        } else {
            deviceToSet = deviceToSet?.id;
        }
        this.setState({
            devices: devices,
            device: deviceToSet
        });

        if (!deviceToSet) {
            await AsyncStorage.removeItem('device');
        } else {
            await AsyncStorage.setItem('device', deviceToSet);
        }
    }

    populateCategories = async () => {
        let categories = await getCategories();
        categories = categories.categories;

        // Check if the category exists in local storage and if it exists in the new categories list, if yes then set it as selected, otherwise ignore
        let asyncStorageCategory = await AsyncStorage.getItem('category');
        let asyncStorageSelectedCategory = await AsyncStorage.getItem('selected_category');
        if (asyncStorageCategory && asyncStorageSelectedCategory) {

            let categoryInList = categories.find(category => String(category._id) == asyncStorageCategory);
            if (categoryInList) {
                await this.setStateAsync({
                    categories: categories,
                    category: asyncStorageCategory,
                    selected_category: JSON.parse(asyncStorageSelectedCategory)
                });
                this.populateSongs();
                return;
            } else {
                await AsyncStorage.removeItem('category');
                await AsyncStorage.removeItem('selected_category');
            }
        }

        await this.setStateAsync({
            categories: categories,
            category: categories?.[0]?._id || '',
            selected_category: categories?.[0] || null
        });
        await AsyncStorage.setItem('category', categories?.[0]?._id);
        await AsyncStorage.setItem('selected_category', JSON.stringify(categories?.[0] || null));

        this.populateSongs();
    }

    populateSongs = async () => {
        let songs = await getSongs({ category: this.state.category });
        songs = songs.songs;

        // Check if the song exists in local storage and if it exists in the new songs list, if yes then set it as selected, otherwise ignore
        let asyncStorageSong = await AsyncStorage.getItem('song');
        let asyncStorageSelectedSong = await AsyncStorage.getItem('selected_song');
        if (asyncStorageSong && asyncStorageSelectedSong) {
            let songInList = songs.find(song => String(song._id) === asyncStorageSong);
            if (songInList) {
                await this.setStateAsync({
                    songs: songs,
                    song: asyncStorageSong,
                    selected_song: JSON.parse(asyncStorageSelectedSong)
                });
                this.setLocalAudio();
                return;
            } else {
                await AsyncStorage.removeItem('song');
                await AsyncStorage.removeItem('selected_song');
            }
        }
        await this.setStateAsync({
            songs: songs,
            song: songs?.[0]?._id || '',
            selected_song: songs?.[0] || null
        });
        await AsyncStorage.setItem('song', songs?.[0]?._id);
        await AsyncStorage.setItem('selected_song', JSON.stringify(songs?.[0] || null));
        this.setLocalAudio();
    }

    setCategoryAndSongFromLocalStorage = async () => {
        try {
            const category = await AsyncStorage.getItem('category');
            const song = await AsyncStorage.getItem('song');
            if (category !== null) {
                // Check whether the category still exists in the categories list, if yes then set it as selected, otherwise ignore
                let categoryId = category;
                let categoryInList = this.state.categories.find(cat => cat._id == categoryId);
                if (categoryInList) {
                    await this.setStateAsync({
                        category: categoryInList._id,
                        selected_category: categoryInList
                    });
                } else {
                    await AsyncStorage.removeItem('category');
                    await AsyncStorage.removeItem('selected_category');
                    return;
                }

                await this.populateSongs();

                if (song !== null) {
                    // Check whether the song still exists in the songs list, if yes then set it as selected, otherwise ignore
                    let songId = song;
                    let songInList = this.state.songs.find(s => s._id == songId);
                    if (songInList) {
                        await this.setStateAsync({
                            song: songInList._id,
                            selected_song: songInList
                        });
                    } else {
                        await AsyncStorage.removeItem('song');
                        await AsyncStorage.removeItem('selected_song');
                    }
                }

            }
        } catch (e) {
            console.log("Error setting category and song from local storage ", e);
        }
    }

    setLocalAudio = async () => {
        try {
            // TODO : Need to get the song's audio and show a player here to play the song from local source, instead of spotify
            let selectedSong = this.state.selected_song;
            if (selectedSong?.audio_source == 'audio_upload') {
                const audio_url = `${config.baseUrl}uploads/${selectedSong?.audio_file?.filename || ''}`;
                this.setState({ local_audio_url: audio_url });
            } else {
                // If the audio source is not 'audio_upload', then we can assume it's spotify and we don't need to do anything here
                this.setState({ local_audio_url: null });
            }
        } catch (error) {
            console.log("Error setting local audio ", error);
            alert(i18n.t('error_setting_local_audio') + ": " + error);
        }
    }

    render() {
        return (
            <View style={{ justifyContent: 'center', alignItems: 'center' }}>

                <Text style={{ margin: 10 }}>{this.state.mqttStatus}</Text>


                <Stack spacing={2} sx={{ width: '80%' }}>

                    <FormControl fullWidth size='small'>
                        <InputLabel id="device-select-label">{i18n.t('device')}</InputLabel>
                        <Select
                            size='small'
                            labelId="device-select-label"
                            id="device-select"
                            value={this.state.device}
                            label={i18n.t('device')}
                            onChange={async (e) => {
                                console.log(e.target.value);
                                await this.setStateAsync({
                                    device: e.target.value
                                });
                                await AsyncStorage.setItem('device', e.target.value);
                            }}
                        >
                            {this.state.devices.map((device, index) => {
                                return (
                                    <MenuItem key={device.id} value={device.id}>{String(device.is_active) + ' - ' + String(device.name) + ' - ' + String(device.type)}</MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>

                    
                    <FormControl fullWidth size='small'>
                        <InputLabel id="category-select-label">{i18n.t('category')}</InputLabel>
                        <Select
                            size='small'
                            labelId="category-select-label"
                            id="category-select"
                            value={this.state.category}
                            label={i18n.t('category')}
                            onChange={async (e) => {
                                console.log(e.target.value);
                                await this.setStateAsync({
                                    category: e.target.value,
                                    selected_category: this.state.categories.find(category => category._id == e.target.value),
                                    song: '',
                                    selected_song: null
                                });
                                await AsyncStorage.setItem('category', e.target.value);
                                await AsyncStorage.setItem('selected_category', JSON.stringify(this.state.categories.find(category => category._id == e.target.value)));
                                this.populateSongs();
                            }}
                        >
                            {this.state.categories.map((category, index) => {
                                return (
                                    <MenuItem key={category._id} value={category._id}>{category.position + ' - ' + category.name}</MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>

                    {(this.state.category) ? (
                        <FormControl fullWidth size='small'>
                            <InputLabel id="song-select-label">{i18n.t('song')}</InputLabel>
                            <Select
                                size='small'
                                labelId="song-select-label"
                                id="song-select"
                                value={this.state.song}
                                label={i18n.t('song')}
                                onChange={async (e) => {
                                    await this.setStateAsync({
                                        song: e.target.value,
                                        selected_song: this.state.songs.find(song => song._id == e.target.value)
                                    });
                                    await AsyncStorage.setItem('song', e.target.value);
                                    await AsyncStorage.setItem('selected_song', JSON.stringify(this.state.songs.find(song => song._id == e.target.value)));
                                    // console.log("Selected song: ", this.state.selected_song);
                                    this.setLocalAudio();
                                }}
                            >
                                {this.state.songs.map((song, index) => {
                                    return (
                                        <MenuItem key={song._id} value={song._id}>
                                            {`${song.sl_no} ${song?.has_release ? (` - ${song?.release?.title || ''}`) : ''} ${song?.has_movie ? (` - ${song?.movie?.name || ''}`) : ''} ${song?.has_artist ? (` - ${song?.artist?.name || ''}`) : ''} ${song?.has_language ? (` - ${song?.language?.name || ''}`) : ''} (ID:${song?._id.slice(-4)})`}
                                        </MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                    ) : null}

                    {(this.state.selected_song) ? (
                        <TextField
                            size='small'
                            placeholder={i18n.t('timeout_seconds')}
                            label={i18n.t('timeout_seconds')}
                            value={this.state.selected_song.time + ' + ' + (this.state.selected_song?.timeline?.solution_display_time || 0)}
                            // onChange={(e) => {
                            //     this.setState({ timeout: e.target.value });
                            // }}
                            disabled
                        />
                    ) : null}

                    {(this.state.selected_song) ? (
                        <Stack direction="row" spacing={1}>

                            {this.state.selected_song.audio_source === 'audio_upload' ? (
                                <Text style={{ fontSize: 12, fontStyle: 'italic', alignSelf: 'center' }}>{i18n.t('local')}</Text>
                            ) : (
                                <Text style={{ fontSize: 12, fontStyle: 'italic', alignSelf: 'center' }}>{i18n.t('spotify')}</Text>
                            )}

                            {/* <Button
                                variant='contained'
                                color='primary'
                                fullWidth
                                disabled={this.state.loading || this.state.playing}
                                onClick={() => {
                                    this.start();
                                }}
                            >
                                {this.state.buttonText}
                            </Button> */}

                            {(this.state.playing || this.state.countdown != '') ? (
                                <Button
                                    variant='outlined'
                                    color='error'
                                    fullWidth
                                    onClick={() => {
                                        this.stop();
                                    }}
                                >
                                    {i18n.t('stop')}
                                </Button>
                            ) : (
                                <Button
                                    variant='contained'
                                    color='primary'
                                    fullWidth
                                    disabled={this.state.loading || this.state.playing}
                                    onClick={() => {
                                        this.start();
                                    }}
                                >
                                    {this.state.buttonText}
                                </Button>
                            )}
                            
                            {this.state.selected_song.is_muted === false ? (
                                <VolumeUpIcon fontSize='large'/>
                            ) : (
                                <VolumeOffIcon fontSize='large'/>
                            )}
                        </Stack>
                    ) : null}

                    

                    {/* {this.state?.local_audio_url ? (
                        <div>
                            <video
                                src={this.state.local_audio_url}
                                controls
                                style={{ width: '100%' }}
                                ref={this.state.video_ref}
                            />
                        </div>
                    ) : null} */}
                    

                    {this.state?.playing_local_audio_url ? (
                        <div style={{ opacity: 0.3 }}>
                            <video
                                src={this.state.playing_local_audio_url}
                                controls
                                style={{ width: '100%' }}
                                ref={this.state.playing_video_ref}
                                onEnded={() => {
                                    this.setState({ playing_local_audio_url: null });
                                }}
                            />
                        </div>
                    ) : null}


                </Stack>

                {(this.state.countdown) ? (
                    <Text style={{ margin: 10, fontSize: 30, fontWeight: 600 }}>{this.state.countdown}</Text>
                ) : null}

            </View>
        )
    }
}

export default Home;
